<template>
    <div class="endDetail">
        <div class="wx_title"><span>XXXX巡园任务</span></div>
        <table class="my_table">
            <thead>
            <tr>
                <th width="170">执行任务时间:</th>
                <th width="210" class="th_background time">
                    <span class="time_val fl">{{time_val}}</span>
                </th>
                <th width="170">任务执行分区:</th>
                <th width="100" class="th_background">A区</th>
                <th width="170">任务作物大类:</th>
                <th class="th_background">柑橘、枇杷</th>
                <th width="140">任务类别:</th>
                <th width="130" class="th_background">{{type}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td colspan="2">执行操作说明</td>
                <td colspan="6">
                    <span>{{textareaSpanVal}}</span>
                </td>
            </tr>
            <tr>
                <td colspan="2" class="tdBack1">任务操作文档</td>
                <td colspan="6" class="tdBack2">XXXX.pdf</td>
            </tr>
            <template v-if="type == '巡园类'">
                <tr>
                    <td rowspan="4" colspan="2">任务内容</td>
                    <td colspan="6">观察植株物候期</td>
                </tr>
                <tr>
                    <td colspan="6">观察植株部位情况：根、茎、叶、花、果</td>
                </tr>
                <tr>
                    <td colspan="6">观察病虫害情况</td>
                </tr>
                <tr>
                    <td colspan="6">观察土壤湿度</td>
                </tr>
            </template>
            <template v-if="type == '打药类'">
                <tr>
                    <td rowspan="6" colspan="2">任务内容</td>
                    <td colspan="6">针对病虫害为：XXXXX,XXXXXX，您的农资有：</td>
                </tr>
                <tr>
                    <td>农资种类</td>
                    <td colspan="2">农资名</td>
                    <td>稀释比例</td>
                    <td>每亩用量</td>
                    <td>剩余量</td>
                </tr>
                <tr>
                    <td>农资</td>
                    <td colspan="2">XX肥料</td>
                    <td>稀释比例为:24</td>
                    <td>1KG</td>
                    <td>34KG</td>
                </tr>
                <tr>
                    <td>激素</td>
                    <td colspan="2">XX肥料</td>
                    <td>稀释比例为:24</td>
                    <td>1KG</td>
                    <td>34KG</td>
                </tr>
                <tr>
                    <td>耗材</td>
                    <td colspan="2">XX肥料</td>
                    <td>稀释比例为:24</td>
                    <td>1KG</td>
                    <td>34KG</td>
                </tr>
            </template>
            <template v-if="type == '营养管理类'">
                <tr>
                    <td rowspan="5" colspan="2">任务内容</td>
                </tr>
                <tr>
                    <td colspan="2">肥料名</td>
                    <td colspan="2">稀释比例</td>
                    <td>每亩用量</td>
                    <td>剩余量</td>
                </tr>
                <tr>
                    <td colspan="2">XX肥料</td>
                    <td colspan="2">稀释比例为:30</td>
                    <td>1KG</td>
                    <td>34KG</td>
                </tr>
                <tr>
                    <td colspan="2">XX肥料</td>
                    <td colspan="2">稀释比例为:30</td>
                    <td>1KG</td>
                    <td>34KG</td>
                </tr>
            </template>
            <template v-if="type == '栽培管理类'">
                <tr>
                    <td colspan="2">任务内容</td>
                    <td colspan="6">
                        <div class="video_box">
                            <span>观看视频:</span>
                            <div class="vdo-img">
                                <a href="javascript:;" class="vode-t" @click="videoClick" v-if="!videoShow">
                                    <img src="../../../../assets/images/image_1.png" />
                                </a>
                                <div class="vdo-play" v-else>
                                    <video id="v_player" src="../../../../assets/images/mp4.mp4" :controls="{'controls':videoShow}" :autoplay="videoShow"></video>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
        <WorkTaskSteps :isActiveNum="isActiveNum" :btnShow="false" @stepsClick="stepsClick"></WorkTaskSteps>
        <div class="wx_title marTop"><span>发表评论</span></div>
        <div class="comment">
            <div class="userImg">
                <img src="../../../../assets/images/home/user_pic_01.png" alt="">
            </div>
            <el-input type="textarea" :autosize="{ minRows: 3}" v-model="comment"></el-input>
        </div>
        <div class="comment_btn">
            <el-button>发表</el-button>
        </div>
        <div class="comment_list">
            <div class="title">评论列表 (3条)</div>
            <div class="item" v-for="item in 2">
                <div class="item_left">
                    <img src="../../../../assets/images/home/user_pic_01.png" alt="">
                </div>
                <div class="item_right">
                    <div class="name">自由天空</div>
                    <p>发表沿路你懂的wwwww发hi是hi看书开始看看是卡卡卡啊啊啊啊啊啊发表沿路你懂的wwwww发hi是hi看书开始看看是卡卡卡啊啊啊啊啊啊发表沿路你懂的ww www发hi是hi看书开始看看是卡卡卡啊啊啊啊啊啊</p>
                    <div class="bottom">
                        <div class="time">45分钟前</div>
                        <div class="btns">
                            <span class="btn reply_btn"><img src="../../../../assets/images/response.png" alt="">回复</span>
                            <span class="btn good_btn"><img src="../../../../assets/images/good.png" alt="">点赞</span>
                        </div>
                    </div>
                    <div class="child">
                        <div class="sub_item">
                            <div class="item_left">
                                <img src="../../../../assets/images/home/user_pic_01.png" alt="">
                            </div>
                            <div class="item_right">
                                <div class="name">自由天空</div>
                                <p>发表沿路你懂的wwwww发hi是hi看书开始看</p>
                                <div class="bottom">
                                    <div class="time">45分钟前</div>
                                    <div class="btns">
                                        <span class="btn reply_btn"><img src="../../../../assets/images/response.png" alt="">回复</span>
                                        <span class="btn good_btn"><img src="../../../../assets/images/good.png" alt="">点赞</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sub_item">
                            <div class="item_left">
                                <img src="../../../../assets/images/home/user_pic_01.png" alt="">
                            </div>
                            <div class="item_right">
                                <div class="name">缘分天空</div>
                                <p>发表沿路你懂的wwwww发hi是hi看书开始看</p>
                                <div class="bottom">
                                    <div class="time">45分钟前</div>
                                    <div class="btns">
                                        <span class="btn reply_btn"><img src="../../../../assets/images/response.png" alt="">回复</span>
                                        <span class="btn good_btn"><img src="../../../../assets/images/good.png" alt="">12</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sub_lenth">全部12条回复</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import WorkTaskSteps from '@/components/WorkTaskSteps';
    export default {
        name: "endDetail",
        data(){
            return{
                isActiveNum:0,
                time_val:'2021.04.15',
                explain:'',
                textareaSpanVal:'读取后台编写的操作说明，这里前台技术员可以更改。读取后台编写的操作说明，这里前台技术员可以更改。',
                // 巡园类，打药类，营养管理类，栽培管理类
                type:'巡园类',
                videoShow:false
            }
        },
        methods:{
            stepsClick(val){
                this.isActiveNum = val
            },
            videoClick(){
                this.videoShow = true
            },
        },
        components: {
            WorkTaskSteps
        }
    }
</script>

<style scoped lang="less">
    .endDetail{
        .my_table{
            margin-top: 35px;
            .th_background{
                background-color: rgba(45, 153, 255, 0.3261);
            }
            .el-textarea__inner{
                text-align: left;
            }
            .tdBack1{
                background-color: rgba(246, 137, 255, 0.46);
            }
            .tdBack2{
                background-color: rgba(246, 137, 255, 0.18);
            }
            .time{
                .time_val{
                    padding-left: 18px;
                }

            }
            .addBtn{
                text-align: right;
                .el-button{
                    margin-right: 28px;
                }
            }
            .video_box{
                text-align: left;
                padding-left: 20px;
                .vdo-img{
                    width:500px;
                    font-size:0;
                    position:relative;
                    text-align: left;
                    margin-top: 15px;
                    .vode-t {
                        display:block;
                        width:100%;
                        position:relative;
                        z-index:2;
                        &:after {
                            content:"";
                            width:89px;
                            height:89px;
                            background:url('../../../../assets/images/ico-display.png') no-repeat;
                            background-size:cover;
                            position:absolute;
                            left:50%;
                            top:50%;
                            margin-left:-44.5px;
                            margin-top:-44.5px;
                        }
                    }
                    img {
                        width: 500px;
                        height: 280px;
                    }
                    video {
                        width:100%;
                        max-height:280px;
                    }
                    .vdo-play {
                        width: 500px;
                        position: relative;
                        left:0;
                        top:0;
                        z-index:1;
                    }
                }
            }
        }
        .marTop{
            margin-top: 55px;
        }
        .comment{
            margin-top: 35px;
            display: flex;
            .userImg{
                width: 80px;
                height: 80px;
                border: 1px solid #979797;
                margin-right: 20px;
                text-align: center;
                img{
                    width: 100%;
                }
            }
        }
        .comment_btn{
            width: 100%;
            margin-top: 20px;
            border-bottom: 2px solid rgba(43, 148, 249, 0.2);
            padding-bottom: 40px;
            overflow: hidden;
            .el-button{
                float: right;
                width: 200px;
                height: 48px;
                line-height: 48px;
                background: #00A1E6;
                font-size: 18px;
                color: #FFFFFF;
                padding: 0;
                border: 0;
                border-radius: 0;
            }
        }
        .comment_list{
            overflow: hidden;
            padding-top: 25px;
            .title{
                font-size: 20px;
                font-weight: bold;
                color: #fff;
            }
            .item{
                margin-top: 40px;
                .item_left{
                    float: left;
                    img{
                        width: 80px;
                        height: 80px;
                    }
                }
                .item_right{
                    margin-left: 100px;
                    .name{
                        font-size: 20px;
                        font-weight: bold;
                        color: #00A1E6;
                        padding-bottom: 10px;
                    }
                    p{
                        font-size: 20px;
                        color: #DDDDDD;
                        line-height: 28px;
                    }
                    .bottom{
                        padding-top: 10px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .time{
                            font-size: 20px;
                            color: #9B9B9B;
                        }
                        .btns{
                            display: flex;
                            .btn{
                                font-size: 20px;
                                color: #ddd;
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                img{
                                    margin-right: 15px;
                                }
                            }
                            .reply_btn{
                                margin-right: 80px;
                            }
                        }
                    }
                    .child{
                        margin-top: 20px;
                        background: rgba(0, 161, 230, 0.1206);
                        border-radius: 1px;
                        overflow: hidden;
                        padding: 22px 10px 26px 21px;
                        .sub_item{
                            margin-bottom: 22px;
                            padding-bottom: 25px;
                            border-bottom: 1px solid rgba(0, 161, 230, 0.2716);
                            .item_left{
                                img{
                                    width: 60px;
                                    height: 60px;
                                }
                            }
                        }
                        .sub_lenth{
                            font-size: 20px;
                            color: #00A1E6;
                            cursor: pointer;
                        }
                    }

                }
            }
        }
    }
</style>
